<template>
  <teleport to="body">
  <div id="main-receipt-list">

  <button type="button" class="btn btn-primary print-button" @click="onClickPrint()">印刷</button>
  <button type="button" class="btn btn-secondary close-button" @click="onClickClose()">閉じる</button>

    <div id="list">
      <Print v-for="(row, index) in getShippingData"
        v-bind:key="index"
        :ref="el => { if (el) tags.push({el}) }"
        >
      </Print>
    </div>

  </div>
  </teleport>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import createStore from '@/store/index.js'
import { createPdfFromHtml } from '@/js/pdf.js'
import Print from '@/components/shipping/Print.vue'

export default defineComponent({
  components: {
    Print
  },
  setup (props, context) {
    const targetRef1 = ref()
    const targetRef2 = ref()
    const targetRef3 = ref()
    const tags = ref([])

    const onClickPrint = () => {
      console.log('test')
      console.log(tags.value)
      // console.log(targetRef1.value)
      // createPdfFromHtml(targetRef1.value.$el)
      const ttt = tags.value.map(x => {
        console.log(x)
        return x.value.el
      })
      createPdfFromHtml(ttt)
      // createPdfFromHtml([targetRef1.value.$el, targetRef2.value.$el, targetRef3.value.$el])
    }

    // 閉じる
    const onClickClose = () => {
      context.emit('closeReceiptPrinter')
    }

    const store = createStore

    const getShippingData = computed(() => {
      console.log(store.getters.getReceiptData)
      return store.getters.getReceiptData
    })

    return {
      targetRef1,
      targetRef2,
      targetRef3,
      getShippingData,
      onClickPrint,
      onClickClose,
      tags
    }
  }
})
</script>

<style lang="scss" scoped>
#main-receipt-list {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  .print-button {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
  }
  .close-button {
    position: absolute;
    top: 0;
    left: 5rem;
    z-index: 100;
  }
  #list {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
